import { h, Fragment } from 'preact'

import cx from 'classnames'

import iconStyle from '@styles/icon.module.css'

import style from './style.module.css'

function ItemCookie({ onToggle, isShow, title, subTitle, detail, children }) {
  return (
    <Fragment>
      <div className={style.itemCookie}>
        <div className={style.menu}>
          <div className={style.menuItem} onClick={onToggle}>
            <span
              className={cx(style.expandIcon, {
                [style.expandIconActive]: isShow,
              })}>
              {isShow ? (
                <i
                  className={`${iconStyle['sn-icon']} ${iconStyle['sn-icon--up']}`}
                />
              ) : (
                <i
                  className={`${iconStyle['sn-icon']} ${iconStyle['sn-icon--down']}`}
                />
              )}
            </span>
            <h3 className={style.modalTitle}>
              {title}
              <span className={style.modalTitleSpan}>({subTitle})</span>
            </h3>
          </div>
          <div className={style.switchButton}>{children}</div>
        </div>
        {isShow && <div className={style.detail}>{detail}</div>}
      </div>
    </Fragment>
  )
}

export default ItemCookie
